import matchHeight from 'jquery-match-height';
import initAos from './initAos';

export default function() {
  $(document).ready(() => {
    if ($('.articles__title').length > 0) {
      $('.articles__title').matchHeight();
    }
    if ($('.articles__excerpt').length > 0) {
      $('.articles__excerpt').matchHeight();
    }
    if ($('.old__box__title').length > 0) {
      $('.old__box__title').matchHeight();
    }
    if ($('.matchHeight').length > 0) {
      $('.matchHeight').matchHeight();
    }

    $.fn.matchHeight._afterUpdate = function(event, groups) {
      initAos();
    }
  });
}
